<template>
  <div class="user_container">
    <div class="top_content">
      <div class="container">
        <div class="goback">
          <div @click="goback" class="left">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
          <div class="userinfo_con" v-if="$route.query.token">
            <div>{{ $route.query.nickName }}</div>
            <div>{{ $route.query.departmentName }}</div>
          </div>
        </div>
        <div class="top">
          <div class="top_one">
            <img
              @click="handleToDetail(newBadge)"
              v-if="newBadge?.iconId"
              class="img1"
              :src="imgUrl + newBadge?.iconId"
              alt=""
            />
            <img
              v-if="!newBadge?.iconId"
              class="img1"
              src="@/assets/newMedal/tuandui.png"
              alt=""
            />
            <div class="top_label_con">
              <div class="top_label" v-if="newBadge?.iconId">最近获得</div>
              <div class="top_label1" v-else>暂未获得</div>
              <div class="top_value">
                <img src="../../../assets/newMedal/icon/left.png" alt="" />
                <span class="value_name" v-if="newBadge?.iconId"
                  >一 {{ newBadge?.medalName }} 一</span
                >
                <span class="value_name1" v-else>一 团队协作 一</span>
                <img src="../../../assets/newMedal/icon/right.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <!-- 
          <div class="tag">
            <div
              v-for="(item, index) in tab"
              :key="index"
              class="tag_item"
              :class="{ active: index == tabIndex }"
              @click="clickTag(index)"
            >
              {{ item }}
            </div>
          </div> -->
        <div class="tag_con">
          <van-tabs v-model="tabValue" @change="changeTabs">
            <van-tab
              v-for="(item, index) in tab"
              :title="item.medalTypeName"
              :key="index"
              :name="item.id"
            >
            </van-tab>
          </van-tabs>
        </div>
        <div class="content">
          <div
            class="list_item"
            v-for="(item, index) in badgeList"
            :key="index"
          >
            <div class="item_header">
              <div class="item_title">{{ item.medalTypeName }}</div>
            </div>
            <div class="item_con">
              <div
                class="badge_item"
                v-for="(badge, ind) in item.medals"
                :key="ind"
                @click="handleBadge(item, badge)"
              >
                <!--  :style="{ opacity: badge.light == 1 ? 2 : 0.25 }" -->
                <img
                  v-if="badge.light == 1"
                  :src="imgUrl + badge.iconId"
                  alt=""
                />
                <img v-else :src="imgUrl + badge.fileId" alt="" />
                <div
                  class="badge_tit"
                  :class="badge.light == 1 ? 'color1' : 'color2'"
                >
                  {{ badge.medalName }}
                </div>
                <div
                  class="sub_tit"
                  :class="badge.light == 1 ? 'color1' : 'color2'"
                >
                  <!-- {{ badge.light == 1 ? "LV" + (badge.medalTypeName == '公益慈善' ? '66' : badge.num) : "未获得" }} -->
                  {{ badge.light == 1 ? "LV" + badge.num : "未获得" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
import { getToken } from "@/utils/cookie";
export default {
  name: "myBadgeList",
  props: {},

  data() {
    return {
      tab: [],
      tabIndex: 0,
      badgeList: [],
      imgUrl: "",
      newBadge: {},
      tabValue: ""
    };
  },

  created() {},
  computed: {},
  mounted() {
    if (localStorage.getItem("tabValue")) {
      this.tabValue = JSON.parse(localStorage.getItem("tabValue"));
    }
    this.imgUrl = api.imgUrl;
    this.queryClassification();
    this.medalCardNewReceived();
    this.queryMyBadge(this.tabValue);
  },
  methods: {
    // 点击返回
    goback() {
      this.$router.go(-1);
    },
    // clickTag(i) {
    //   this.tabIndex = i;
    //   this.queryMyBadge();
    // },
    // 获取所有徽章
    queryMyBadge(id) {
      api
        .myBadgeApi({
          cardType: this.tabIndex == 0 ? "" : this.tabIndex,
          empno: this.$route.query.token ? this.$route.query.token : getToken(),
          id
        })
        .then(res => {
          if (res.code == 200) {
            this.badgeList = res.data.map(item => {
              if (item.cardType == 3) {
                item.medals.sort((a, b) => a.companyAge - b.companyAge);
              }
              if (item.cardType == 4) {
                item.medals.sort((a, b) => a.unlockDuration - b.unlockDuration);
                // item.medals = item.medals.filter(i => i.medalWhether == 1);
              }
              return item;
            });
          }
        });
    },
    // 获取最新徽章
    medalCardNewReceived() {
      const json = {
        recordType: 1,
        empno: getToken()
        // yearMonth: moment().format("YYYY-MM")
      };
      api.medalCardNewReceivedApi(json).then(res => {
        if (res.code == 200) {
          this.newBadge = res.data[0];
        }
      });
    },
    // 切换tab
    changeTabs(name) {
      this.queryMyBadge(name);
    },
    // 点击徽章
    queryClassification() {
      const json = {
        page: 1,
        pageSize: 2000
      };
      api.queryDataMedalType(json).then(res => {
        if (res.code == 200) {
          this.tab = res.data;
          this.tab.unshift({
            medalTypeName: "全部",
            id: ""
          });
        }
      });
    },
    // 点击查看徽章详情
    handleBadge(item, badge) {
      if (!this.$route.query.token) {
        localStorage.setItem("cardItem", JSON.stringify(item));
        localStorage.setItem("badgeItem", JSON.stringify(badge));
        localStorage.setItem("tabValue", JSON.stringify(this.tabValue));

        this.$router.push(
          `/mobile/medal/timeCoronation?type=${
            item.cardType == 1
              ? 1
              : item.cardType == 2
              ? 3
              : item.cardType == 3
              ? 2
              : item.cardType == 4
              ? 4
              : null
          }&token=${
            this.$route.query.token ? this.$route.query.token : getToken()
          }`
        );
      }
    },
    // 点击查看徽章详情
    handleToDetail(detail) {
      if (detail?.cardType == 1) {
        this.$router.push({
          path: "/mobile/medal/quaquakaDetail",
          query: {
            id: detail?.id
          }
        });
      }
      if (detail?.cardType == 3) {
        this.$router.push({
          path: "/mobile/medal/badgeDetail",
          query: {
            id: this.itemInfo?.id
          }
        });
      }
      if (detail?.cardType == 2) {
        this.$router.push({
          path: "/mobile/medal/newsNotice/medalDetail",
          query: {
            id: detail?.id
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 256px * $zoom;
  }
}

.user_container {
  min-height: 100vh;
  position: relative;
  margin: auto;
  font-size: 1vh;
  background-color: #f7f9fa;

  .container {
    // background-image: url("~@/assets/newsNotice/background3.png");
    background-image: url("~@/assets/newMedal/bg5.png");
    background-size: 100% 100%;
    height: 100vh;
    padding: 30px 0;
    .goback {
      padding: 10px 40px 0px 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      position: relative;
      z-index: 9999;

      .left {
        display: flex;
        align-items: center;
      }

      i {
        font-weight: bold;
        font-size: 48px;
        margin-right: 40px;
      }

      span {
        font-size: 34px;
      }
      .userinfo_con {
        font-size: 24px;
        div {
          height: 35px;
        }
      }
    }
    .top {
      position: absolute;
      top: 4vh;
      left: 0%;
      width: 100%;
      display: flex;
      justify-content: center;
      .top_one {
        text-align: center;
      }
      .img1 {
        height: 22vh;
        // width: 350px;
        // height: 180px;
      }
      .top_label_con {
        position: absolute;
        top: 21vh;
        right: 0;
        left: 0;
        margin: 0 auto;
      }
      .top_label {
        color: #fff;
        font-size: 28px;
        margin-top: 0%;
      }
      .top_label1 {
        color: #666;
        font-size: 28px;
        margin-top: 0%;
      }
      .top_value {
        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 38px;
        margin-top: 1%;
        span {
          margin: 0 20px;
        }
        .value_name {
          color: #fff;
        }
        .value_name1 {
          color: #666;
        }
      }
    }
    .tag_con {
      width: 100%;
      position: absolute;
      top: 32vh;
      left: 0;

      ::v-deep {
        .van-tabs {
          width: 100%;
          border-bottom: 1px solid #979797;
        }
        .van-tabs__nav {
          background-color: initial;
          color: #666666;
        }
        .van-tab--active {
          color: #fff;
        }
        .van-tabs__line {
          background: #1fbe8a;
        }
      }
    }
    .tag {
      position: absolute;
      top: 34vh;
      left: 0;
      border-bottom: 1px solid #979797;
      padding-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-wrap: nowrap;
      overflow-x: auto;
      width: 100%;
      font-size: 30px;
      color: #666666;
      z-index: 999;
      &::-webkit-scrollbar {
        display: none;
      }
      .tag_item {
        position: relative;
        flex-shrink: 0;
        margin: 0 10px;
      }
      .active {
        color: #fff;
        &::before {
          content: "";
          display: block;
          width: 100%;
          height: 4px;
          background: #1fbe8a;
          position: absolute;
          bottom: -50%;
          left: 0;
        }
      }
    }
    .content {
      position: absolute;
      top: 40vh;
      left: 5%;
      width: 90%;
      height: 59vh;
      background: #373b43;
      border-radius: 30px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .list_item {
        .item_header {
        }
        .item_title {
          font-weight: 600;
          font-size: 29px;
          color: #70737a;
          margin: 30px 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .item_con {
          display: flex;
          flex-wrap: wrap;
          .badge_item {
            width: 25%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 50px;
            img {
              width: 100%;
              // height: 106px;
            }
            .badge_tit {
              font-weight: 500;
              font-size: 25px;
              margin: -5px 0 10px 0;
            }
            .sub_tit {
              font-weight: 400;
              font-size: 20px;
            }
            .color1 {
              color: #fff;
            }
            .color2 {
              color: #666666;
            }
          }
        }
      }
    }
  }
}
</style>
